<template>
    <div v-if="flashcards && flashcards.length > 0">
        <div class="card-body shadow rounded">
            <p class="d-inline-flex gap-1 m-2">
                <a data-bs-toggle="collapse" href="#flashcardsTab" role="button" aria-expanded="true" aria-controls="flashcardsTab" @click="this.collapsed = !this.collapsed">
                    <svg class="icon icon-primary fixed-icon">
                    <use :href='this.$root.baseURL + "/bootstrap-italia/dist/svg/sprites.svg#" + (this.collapsed ? "it-expand" : "it-collapse")'></use>
                    </svg>
                    Flashcard
                </a>
            </p>
            <hr class="my-0">
            <div v-if="flashcards && flashcards.length > 0" class="container-fluid p-0 m-0 show" id=flashcardsTab>
                <div class="flashcard-container row">
                    <div v-for="flashcard in flashcards" :key="flashcard.id" class="col-12 col-lg-6 col-xl-4 p-4">
                        <div class="flashcard">
                            <div class="flashcard-inner" :class="{ 'flipped': flashcard.flipped }">
                                <div class="flashcard-front">
                                    <h5>{{ flashcard.question }}</h5>
                                    <button class="btn btn-outline-primary mt-3" @click="flipCard(flashcard)">Mostra risposta</button>
                                </div>
                                <div class="flashcard-back">
                                    <h5>Risposta:</h5>
                                    <div class="flashcard-content-scrollable">
                                        <p>
                                            {{flashcard.answer}}
                                        </p>
                                    </div>
                                    <button class="btn btn-outline-primary mt-3" @click="flipCard(flashcard)">Nascondi risposta</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FlashCards",
    props: {
        flashcards: Array,
    },
    data() {
        return {
            isModalVisible: false,
            currentIndex: 0,
            isFlipped: false,
            collapsed: false
        }
    },
    computed: {
        currentFlashcard() {
            return this.flashcards && this.flashcards.length > 0 ? this.flashcards[this.currentIndex] : { question: '', answer: '' };
        }
    },
    methods: {
        showFlashcards() {
            this.isModalVisible = true;
            this.currentIndex = 0;
            this.isFlipped = false;
            document.body.classList.add('modal-open');
        },
        flipCard(flashcard) {
            flashcard.flipped = !flashcard.flipped;
        }
    }
}
</script>

<style scoped>
.flashcard-container {
    perspective: 1000px;
    margin: 0 auto;
}

.flashcard {
    width: 100%;
    height: 300px;
    margin: 0 auto;
}

.flashcard-inner {
    position: relative;
    width: 100%;
    height: 100%;
    text-align: center;
    transition: transform 0.6s;
    transform-style: preserve-3d;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    border-radius: 10px;
}

.flashcard-inner.flipped {
    transform: rotateY(180deg);
}

.flashcard-front, .flashcard-back {
    position: absolute;
    width: 100%;
    height: 100%;
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
    border-radius: 10px;
    background-color: #f8f9fa;
}

.flashcard-front {
    background-color: #f8f9fa;
}

.flashcard-back {
    background-color: #e9ecef;
    transform: rotateY(180deg);
}

.card-counter {
    display: flex;
    align-items: center;
    font-weight: bold;
}

.circle-button {
    width: 50px;
    height: 50px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
}

.flashcard-content-scrollable {
    max-height: 180px;
    overflow-y: auto;
    width: 100%;
    padding: 0 10px;
    margin-bottom: 10px;
    scrollbar-width: thin;
}

.flashcard-content-scrollable p {
    text-align: left;
}
</style>